import { combineReducers } from 'redux';

/** IMPORT REDUCER */
import excecaoMeta from './excecaoMeta/reducer';
import recalculaTurno from './recalculaTurno/reducer';
import alteracaoCentroCusto from './alteracaoCentroCusto/reducer';
import tiposDeEquipamentosVeiculo from './tiposDeEquipamentosVeiculo/reducer';

import recebimentoAreiaNf from './recebimentoAreiaNf/reducer';
import transferenciaAreiaSilo from './transferenciaAreiaSilo/reducer';
import afericaoAreiaSilo from './afericaoAreiaSilo/reducer';
import afericaoDvec from './afericaoDvec/reducer';
import alarmeSistema from './alarmeSistema/reducer';
import alarmesSistemas from './alarmesSistemas/reducer';
import arqueacao from './arqueacao/reducer';
import arqueacaoautomatica from './arqueacaoAutomatica/reducer';
import auditoriaSistemas from './auditoriaSistemas/reducer';
import auth from './auth/reducer';
import bico from './bico/reducer';
import cadastrodvec from './cadastrodvec/reducer';
import causasManutencoes from './causasManutencoes/reducer';
import centrocusto from './centrocusto/reducer';
import cercasvirtuais from './cercasVirtuais/reducer';
import checkliberadoparaintegracao from './checkliberadoparaintegracao/reducer';

import fechamentolmc from './fechamentolmc/reducer';
import conversorEntradaSaida from './conversorEntradaSaida/reducer';
import distribuidora from './distribuidora/reducer';
import drawer from './drawer/reducer';
import edicaoAlinhamentoTanque from './EdicaoOperacao/AlinhamentoTanque/reducer';
import recebimento from './EdicaoOperacao/Recebimento/reducer';
import edicaoTrocaTanque from './EdicaoOperacao/TrocaTanque/reducer';
import turno from './EdicaoOperacao/Turno/reducer';
import empresacliente from './empresacliente/reducer';
import empresaveiculo from './empresaveiculo/reducer';
import estoqueGeralModulosProdutos from './estoqueGeralModulosProdutos/reducer';
import estoqueproduto from './estoqueproduto/reducer';
import gerencias from './gerencias/reducer';
import hooks from './hooks/reducer';
import inversorFrequencia from './inversorFrequencia/reducer';
import justificativaAlteracaoEncerrante from './justificativaAlteracaoEncerrante/reducer';
import justificativaContingencia from './justificativaContingencia/reducer';
import justificativaTrocaModoOperacional from './justificativaTrocaModoOperacional/reducer';
import language from './language/reducer';
import linhaAbastecimento from './linhaAbastecimento/reducer';
import localidade from './localidade/reducer';
import mensagemSistemaEquipamento from './mensagemSistemaEquipamento/reducer';
import mensagemSistemaEquipamentoPosto from './mensagemSistemaEquipamentoPosto/reducer';
import mensagemSistemaFrentista from './mensagemSistemaFrentista/reducer';
import mensagemSistemaMotorista from './mensagemSistemaMotorista/reducer';
import mensagemSistemaoEquipamentoKm from './mensagemSistemaoEquipamentoKm/reducer';
import mensagemSistemaOperacaoAgricola from './mensagemSistemaOperacaoAgricola/reducer';
import mensagemsistemaposto from './mensagemsistemaposto/reducer';
import checkxmlnfrecebimentonf from './checkxmlnfrecebimentonf/reducer';
import clienteConfig from './clienteConfig/reducer';
import comboio from './comboio/reducer';
import configuracaoalarmetanque from './configuracaoalarmetanque/reducer';
import consultaavancada from './consultaAvancada/reducer';
import contrato from './contrato/reducer';
import dialog from './dialog/reducer';
import dialogForm from './dialogForm/reducer';
import locomotiva from './locomotiva/reducer';
import marcasveiculo from './marcasveiculo/reducer';
import medidor from './medidor/reducer';
import modeloveiculo from './modeloveiculo/reducer';
import modulosCliente from './modulosCliente/reducer';
import motorista from './motorista/reducer';
import notafiscalrecebida from './notafiscalrecebida/reducer';
import notification from './notification/reducer';
import operacao from './operacao/reducer';
import operacaoabastecimento from './operacaoabastecimento/reducer';
import operacaoabastecimentoexterno from './operacaoabastecimentoexterno/reducer';
import operacaoafericao from './operacaoafericao/reducer';
import operacaobatelada from './operacaobatelada/reducer';
import operacaoBateriaDbic from './operacaoBateriaDbic/reducer';
import operacaodiagnostico from './operacaodiagnostico/reducer';
import operacaoestoqueposto from './operacaoestoqueposto/reducer';
import operacaoestoquetanque from './operacaoestoquetanque/reducer';
import operacaoLimpezaDvec from './operacaoLimpezaDvec/reducer';
import operacaoLimpezaTag from './operacaoLimpezaTag/reducer';
import operacaoLubrificacao from './operacaoLubrificacao/reducer';
import operacaomedicaotemperatura from './operacaomedicaotemperatura/reducer';
import operacaodreno from './operacaodreno/reducer';
import operacaorecebimento from './operacaorecebimento/reducer';
import operacaoRecebimentoNf from './operacaoRecebimentoNf/reducer';
import operacaoTotalizadorVeiculo from './operacaoTotalizadorVeiculo/reducer';
import operacaotransferencia from './operacaotransferencia/reducer';
import operacaovazaonaoautorizada from './operacaovazaonaoautorizada/reducer';
import perfilFrentista from './perfilFrentista/reducer';
import perfis from './perfis/reducer';
import pitStopJustificativa from './pitStopJustificativa/reducer';
import pitStopRegra from './pitStopRegra/reducer';
import posto from './posto/reducer';
import precoproduto from './precoproduto/reducer';
import preset from './preset/reducer';
import produto from './produto/reducer';
import raizenerrologintegracao from './raizenerrologintegracao/reducer';
import raizenerrologintegracaoentradacomboio from './raizenerrologintegracaoentradacomboio/reducer';
import raizenerrologintegracaomovimentacaocomboio from './raizenerrologintegracaomovimentacaocomboio/reducer';
import raizenerrologintegracaomovimentacaoposto from './raizenerrologintegracaomovimentacaoposto/reducer';
import raizenerrologintegracaotransferencia from './raizenerrologintegracaotransferencia/reducer';
import retransregisintegracao from './retransregisintegracao/reducer';
import safras from './safras/reducer';
import tagcomrestricao from './tagcomrestricao/reducer';
import tanquefisico from './tanquefisico/reducer';
import tanquevirtual from './tanquevirtual/reducer';
import terminal from './terminal/reducer';
import tipoAreia from './tipoAreia/reducer';
import transportadora from './transportadora/reducer';
import uploadplanilhacliente from './uploadplanilhacliente/reducer';
import user from './user/reducer';

import usuario from './usuario/reducer';
import usuariofrentista from './usuariofrentista/reducer';
import veiculo from './veiculo/reducer';

import logsdescarregamentos from './LogsDescarregamentos/reducer';
import logsdescarregamentositem from './LogsDescarregamentosItem/reducer';
import locomotivaRegistration from './locomotivaRegistration/reducer';
import manutencaoDvec from './manutencaoDvec/reducer';
import corredor from './corredor/reducer';
import estoqueAreia from './estoqueAreia/reducer';

export default combineReducers({
  /** EXPORT REDUCER */
  excecaoMeta,
  recalculaTurno,
  alteracaoCentroCusto,
  recebimentoAreiaNf,
  transferenciaAreiaSilo,
  afericaoAreiaSilo,
  tiposDeEquipamentosVeiculo,
  retransregisintegracao,
  raizenerrologintegracaoentradacomboio,
  raizenerrologintegracaomovimentacaocomboio,
  raizenerrologintegracaomovimentacaoposto,
  raizenerrologintegracaotransferencia,
  raizenerrologintegracao,
  checkxmlnfrecebimentonf,
  preset,
  checkliberadoparaintegracao,
  transportadora,
  distribuidora,
  fechamentolmc,
  notafiscalrecebida,
  linhaAbastecimento,
  inversorFrequencia,
  pitStopRegra,
  pitStopJustificativa,
  mensagemSistemaoEquipamentoKm,
  mensagemSistemaOperacaoAgricola,
  mensagemSistemaMotorista,
  mensagemSistemaFrentista,
  mensagemSistemaEquipamentoPosto,
  mensagemSistemaEquipamento,
  mensagemsistemaposto,
  perfilFrentista,
  uploadplanilhacliente,
  empresacliente,
  clienteConfig,
  modulosCliente,
  tagcomrestricao,
  afericaoDvec,
  manutencaoDvec,
  edicaoAlinhamentoTanque,
  edicaoTrocaTanque,
  recebimento,
  turno,
  justificativaContingencia,
  justificativaAlteracaoEncerrante,
  estoqueGeralModulosProdutos,
  operacaoBateriaDbic,
  auditoriaSistemas,
  justificativaTrocaModoOperacional,
  alarmeSistema,
  alarmesSistemas,
  operacaoLubrificacao,
  perfis,
  gerencias,
  causasManutencoes,
  safras,
  operacaoTotalizadorVeiculo,
  operacaoLimpezaDvec,
  operacaoLimpezaTag,
  operacaoRecebimentoNf,
  auth,
  bico,
  drawer,
  notification,
  language,
  medidor,
  produto,
  precoproduto,
  comboio,
  dialog,
  posto,
  terminal,
  tipoAreia,
  estoqueAreia,
  motorista,
  empresaveiculo,
  estoqueproduto,
  hooks,
  user,
  modeloveiculo,
  operacao,
  operacaoabastecimento,
  operacaoabastecimentoexterno,
  operacaoestoqueposto,
  operacaoestoquetanque,
  operacaorecebimento,
  operacaovazaonaoautorizada,
  operacaotransferencia,
  marcasveiculo,
  centrocusto,
  cercasvirtuais,
  contrato,
  usuario,
  usuariofrentista,
  veiculo,
  locomotiva,
  tanquevirtual,
  tanquefisico,
  arqueacao,
  configuracaoalarmetanque,
  consultaavancada,
  localidade,
  operacaoafericao,
  cadastrodvec,
  operacaobatelada,
  operacaodiagnostico,
  operacaomedicaotemperatura,
  operacaodreno,
  arqueacaoautomatica,
  logsdescarregamentos,
  logsdescarregamentositem,
  locomotivaRegistration,
  dialogForm,
  corredor,
  conversorEntradaSaida,
});
